import React, { useState } from 'react';
// @ts-ignore
import styles from './EReceptList.module.scss';
import LinkButton from '../../Button/LinkButton';
// @ts-ignore
import moment, { Moment } from 'moment';
import { Theme } from '../../../Enums/Theme.enum';
import MediaViewerModal from '../../MediaViewer/MediaViewerModal';
import { useAppContext } from '../../../Services/AppContext';
import EReceptListItemDefault from './EReceptListItemDefault';
import ElectronicPrescriptionModal from '../../../Modules/Prescription/Components/ElectronicPrescriptionModal';
import apiClient from '../../../Services/ApiClient';
import { useIsLatam } from '../../../Modules/Region/Services/region.service';
import { getMomentDate } from '../../../Utils/dates.util';
import useTranslation from '../../../Hooks/useTranslation';
import EReceptListItemSuklPerMedicament from './EReceptListItemSuklPerMedicament/EReceptListItemSuklPerMedicament';

export interface EReceptListLitemProps {
	patientId: string;
	item: EReceptRow;
	key: string;
	showMoreInfo?: boolean;
	refreshList?: () => void;
}

export interface EReceptRow {
	id: string;
	validUntil: Date;
	items: [EReceptRowItem];
	type: string;
	title: string;
	code: string;
	quantity: string;
	createdAt: string;
	data?: any;
	showDate?: boolean;
}

export interface EReceptRowItem {
	id: string;
	quantity: string;
	extra: {
		concentration: string;
		medicine: string;
		amount: string;
		iplp?: {
			name: string;
			form: string;
			routeOfAdministration: string;
			instruction: string;
		};
	};
	prescriptionMedicament: {
		id: string;
		name: string;
		code: string;
		addition: string;
		strength?: string;
		form?: string;
		packaging?: string;
		atc?: string;
		routeOfAdministration?: string;
	};
}

export default function EReceptListItem(props: EReceptListLitemProps) {
	const { patientId, item, refreshList } = props;
	const { links, globalTemplate, dateFormatMoment } = useAppContext();
	const [mediaViewerOpened, setMediaViewerOpened] = useState(false);
	const [showCreatePrescription, setShowCreatePrescription] = useState(false);
	const [duplicateData, setDuplicateData] = useState();
	const [showMoreInfo, setShowMoreInfo] = useState(false);
	const isLatam = useIsLatam(globalTemplate);
	const { t } = useTranslation();

	const handleOpenDetail = () => {
		setMediaViewerOpened(true);
	};

	const handleDuplicate = async (id: string) => {
		const result = await apiClient.get(`/prescription/${item.id}/duplicate`);
		if (result) {
			if (result.data?.formData?.default?.medicaments?.hvlp?.length) {
				result.data.formData.default.medicaments.hvlp =
					result.data.formData.default.medicaments.hvlp.filter(
						(item: any) => item.item.id === id,
					);
			}
			//if (result?.data?.formData?.default?.medicaments?.iplp?.length) {
			//	result.data.formData.default.medicaments.iplp =
			//		result.data?.formData?.default?.medicaments?.iplp?.filter(
			//			(item: any) => item.item.id === id,
			//		);
			//}
			console.log('result.data', result.data);
			setDuplicateData(result.data);
			setShowCreatePrescription(true);
		}
	};

	const handleShowMoreInfo = () => {
		setShowMoreInfo(prev => !prev);
	};

	const prescriptionLinkSukl = links.treatment.downloadPrescriptionSukl
		.replace('__PATIENT__', patientId)
		.replace('__ID__', item.id);

	const prescriptionLink = links.treatment.downloadPrescription
		.replace('__PATIENT__', patientId)
		.replace('__ID__', item.id);

	const selectedFile = {
		id: item.id,
		name: t('base.ePrescription') + (item.code ? ' (' + item.code + ')' : ''),
		displayName:
			t('base.ePrescription') + (item.code ? ' (' + item.code + ')' : ''),
		type: 'pdf',
		preview: item.type === 'sukl' ? prescriptionLinkSukl : prescriptionLink,
		download: item.type === 'sukl' ? prescriptionLinkSukl : prescriptionLink,
	};

	const modals = (
		<>
			{mediaViewerOpened && (
				<MediaViewerModal
					opened
					onClose={() => setMediaViewerOpened(false)}
					file={selectedFile}
				/>
			)}
			{duplicateData && showCreatePrescription && (
				<ElectronicPrescriptionModal
					opened
					onClose={() => setShowCreatePrescription(false)}
					onCreate={() => refreshList?.()}
					patientId={patientId}
					defaultValues={duplicateData}
					discardOnClose
				/>
			)}
		</>
	);

	if (item.type === 'sukl') {
		return (
			<>
				<EReceptListItemSuklPerMedicament
					patientId={patientId}
					item={item}
					key={item.id}
					handleOpenDetail={handleOpenDetail}
					handleDuplicate={handleDuplicate}
				/>
				{modals}
			</>
		);
	}

	return (
		<div className={styles.item}>
			<div className={styles.patient}>
				<div className={styles.patientData}>
					<div className={styles.text}>
						{getMomentDate(item.createdAt).format(dateFormatMoment)}
					</div>
				</div>
			</div>
			<EReceptListItemDefault
				item={item}
				key={item.id}
				patientId={patientId}
				showMoreInfo={showMoreInfo}
			/>
			<div className={styles.controls}>
				<LinkButton
					onClick={handleOpenDetail}
					title={t('component.ePrescription.detail') ?? ''}
					theme={Theme.BLUE}
				/>
			</div>
			{modals}
		</div>
	);
}
